module.exports = __webpack_public_path__ + "static/media/bring-bottom.a95a00a7.svg";